(function () {
    'use strict';
    /**
     * @memberof appback
     *@ngdoc service
     *@name WorkOrdersService
     *@description
     *Servicio del calendario de órdenes de trabajo
     */

    angular
        .module('appback')
        .factory('WorkOrdersService', WorkOrdersService);

    WorkOrdersService.$inject = ["$http"];

    function WorkOrdersService($http) {

        var service = {
            GetWorkOrders: GetWorkOrders
        };

        function GetWorkOrders(params) {
            return $http.get('/backend/workorders/get-work-orders', {
                params: params
            }).then(function (response) {
                return response.data;
            }, function (error) {
                return error;
            });
        }

        return service;
    }
})();
